/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _navKeys = _interopRequireDefault(require("./navKeys"));
function _default(event) {
  var key = event.key;
  if (this.props.onKeyDown) {
    if (this.props.onKeyDown(event) === false) {
      return;
    }
  }
  if (key == 'Enter' && this.p.activeDate) {
    this.confirm(this.p.activeDate, event);
  }
  var navKeys = this.p.navKeys || _navKeys.default;
  var dir = navKeys[key];
  if (!dir) {
    return;
  }
  event.preventDefault();
  this.navigate(dir, event);
}


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/Calendar/src/MonthView/onKeyDown.js
// module id = 234
// module chunks = 0